import React, { useState } from "react"
import PropTypes from "prop-types"
import { components } from "react-select"
// import Creatable from "react-select/creatable"
import AsyncSelect from "react-select/async"
import AsyncCreatableSelect from "react-select/async-creatable"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import Paper from "@material-ui/core/Paper"
import MenuItem from "@material-ui/core/MenuItem"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import styles from "./styles"
import {
  getUsersByInput,
  getUsers,
  getLocationByInput,
  getRolesByInput,
  getCompaniesByInput,
  getEquipmentByInput,
  getShootsByInput,
  getClientsByInput,
} from "../../actions/misc"
import { useEffect } from "react"
import { connect, useSelector } from "react-redux"
import store from "../../store"
import _, { isEmpty } from "lodash"
import moment from "moment"
import { convertToAbbr } from "../../lib/states.js"
import { pluralize } from "inflection"

const useStyles = makeStyles(styles)

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      No Results Found
    </Typography>
  )
}

NoOptionsMessage.propTypes = {
  innerProps: PropTypes.object.isRequired,
  selectProps: PropTypes.object.isRequired,
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />
}

inputComponent.propTypes = {
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any.isRequired,
    }),
  ]),
}

function Control(props) {
  const {
    children,
    innerProps,
    innerRef,
    selectProps: { classes, TextFieldProps },
  } = props

  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        classes: {
          ...props.selectProps.InputClasses,
        },
        inputProps: {
          className: classes.input,
          ref: innerRef,
          children,
          ...innerProps,
        },
      }}
      {...TextFieldProps}
      label=""
    />
  )
}

Control.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.shape({
    onMouseDown: PropTypes.func.isRequired,
  }).isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any.isRequired,
    }),
  ]).isRequired,
  selectProps: PropTypes.object.isRequired,
}

function Option(props) {
  if (props.selectProps.placeholder === "Search Shoots") {
    return (
      <MenuItem
        // ref={props.innerRef}
        selected={props.isFocused}
        component="div"
        style={{
          fontWeight: props.isSelected ? 500 : 400,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
        {...props.innerProps}
      >
        <Typography variant="p">{props.children.label}</Typography>
        <Typography variant="caption">
          Dated: {moment(props.children.date).format("MMM DD, YYYY")}
        </Typography>
        <Typography variant="caption">
          Status: {props.children.status}
        </Typography>
        <Typography variant="caption">
          Creator: {props.children.creator}
        </Typography>
        {props.children.location &&
          props.children.location.city && (
            <Typography variant="caption">
              {`Location: ${props.children.location.city}, 
  ${_.head(convertToAbbr(props.children.location.state)) &&
    _.head(convertToAbbr(props.children.location.state)).abbr}`}
            </Typography>
          )}
      </MenuItem>
    )
  } else {
    return (
      <MenuItem
        // ref={props.innerRef}
        selected={props.isFocused}
        component="div"
        style={{
          fontWeight: props.isSelected ? 500 : 400,
        }}
        {...props.innerProps}
      >
        {props.children}
      </MenuItem>
    )
  }
}

Option.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.shape({
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onMouseMove: PropTypes.func.isRequired,
    onMouseOver: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired,
  }).isRequired,
  isFocused: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
}

function Placeholder(props) {
  const { selectProps, innerProps = {}, children } = props
  return (
    <Typography
      color="textSecondary"
      className={selectProps.classes.placeholder}
      {...innerProps}
    >
      {children}
    </Typography>
  )
}

Placeholder.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  )
}

SingleValue.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.object.isRequired,
}

function ValueContainer(props) {
  return (
    <div
      className={props.selectProps.classes.valueContainer}
      style={
        props.selectProps.placeholder === "Search Expense"
          ? { height: 29 }
          : { height: 40 }
      }
    >
      {props.children}
    </div>
  )
}

ValueContainer.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.object.isRequired,
}

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  )
}

Menu.propTypes = {
  children: PropTypes.element.isRequired,
  innerProps: PropTypes.object.isRequired,
  selectProps: PropTypes.object.isRequired,
}

const MenuList = props => {
  return (
    <components.MenuList
      {...props}
      className={props.selectProps.classes.menuList}
    >
      {props.children}
    </components.MenuList>
  )
}

const replaceComponents = {
  Control,
  Menu,
  MenuList,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
  IndicatorSeparator: null,
  DropdownIndicator: props => {
    return props.isFocused ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
  },
}

const loadOptions = async (
  prop,
  inputValue,
  callback,
  labelKey,
  placeholder,
  suggestions
) => {
  if (inputValue.length && labelKey == "full_name") {
    await prop.dispatch(getUsersByInput(inputValue))
    var test = store.getState()
    var data = test.misc.users
  }

  if (inputValue.length && labelKey == "locations") {
    await prop.dispatch(getLocationByInput(inputValue))
    var test = store.getState()
    var data = test.misc.locations
  }

  if (
    (inputValue.length && placeholder == "Search Equipment") ||
    placeholder == "Additional Equipment"
  ) {
    await prop.dispatch(getEquipmentByInput(inputValue))
    var test = store.getState()
    var data = test.misc.equipment
  }
  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Search Position"
  ) {
    await prop.dispatch(getRolesByInput(inputValue))
    var test = store.getState()
    var data = test.misc.roles
  }
  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Search Company"
  ) {
    await prop.dispatch(getCompaniesByInput(inputValue))
    var test = store.getState()
    var data = test.misc.companies
  }

  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Select Company User"
  ) {
    var test = store.getState()
    var rawData = test.clients.companyClients.map(cc => {
      return { id: cc.id, name: cc.first_name + " " + cc.last_name }
    })
    var filteredData = rawData
      .map(
        (s, i) =>
          s.name.toLowerCase().includes(inputValue.toLowerCase()) ? s : null
      )
      .filter(el => el != null)
    var data = filteredData
  }

  // Search Company User in shoots

  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Search Company User"
  ) {
    await prop.dispatch(getClientsByInput(inputValue))
    var test = store.getState()
    var data = test.misc.clients
  }

  // Search Company User in shoots ends here

  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Search Positions"
  ) {
    var test = store.getState()
    var roles = test.misc.childParentRoles
    console.log("roles", roles)
    var searchedParentRoles = roles.parents
      .map(
        (s, i) =>
          s.name.toLowerCase().includes(inputValue.toLowerCase()) ? s : null
      )
      .filter(el => el != null)
    var searchedChildRoles = roles.children
      .map(
        (s, i) =>
          s.name.toLowerCase().includes(inputValue.toLowerCase()) ? s : null
      )
      .filter(
        el =>
          el != null &&
          roles.connections.find(
            c => c.child_role_id === el.id && c.parent_role_id
          )
      )

    let newPosition = searchedParentRoles.concat(searchedChildRoles)
    var data = newPosition.map(item => {
      return {
        ...item,
        searchValue: "positionSearch",
      }
    })
  }
  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Search Shoots"
  ) {
    // var options = store.getState();
    // var activeCompany = options.companies.activeCompany
    // var sending = {}
    // sending.activeCompany = activeCompany;
    // sending.searchKey = inputValue

    await prop.dispatch(getShootsByInput(inputValue))

    // await prop.dispatch(getRolesByInput(inputValue))
    var test = store.getState()
    var data = test.misc.shoots
  }
  if (inputValue.length && labelKey == "name" && placeholder == "Search Role") {
    var searchedRoles = suggestions
      .map(
        (s, i) =>
          s.name.toLowerCase().includes(inputValue.toLowerCase()) ? s : null
      )
      .filter(el => el != null)
    var data = searchedRoles
  }

  if (
    inputValue.length &&
    labelKey == "name" &&
    placeholder == "Search Expense"
  ) {
    var searchedExpenses = suggestions
      .map(
        (s, i) =>
          s.name.toLowerCase().includes(inputValue.toLowerCase()) ? s : null
      )
      .filter(el => el != null)
    var data = searchedExpenses
  }
  callback(
    data
    //     .filter(
    //       x =>
    //         x[labelKey] &&
    //         x[labelKey].search &&
    //         x[labelKey].search(new RegExp(inputValue, "i")) >= 0
    //     )
    //     .slice(0, 10)
  )
}

function IntegrationReactSelect({
  creatable,
  placeholder,
  suggestions,
  labelKey,
  onChange,
  checkKey,
  newValue,
  prop,
  prrop,
  ...props
}) {
  const classes = useStyles()
  const theme = useTheme()
  const [value, setValue] = React.useState(newValue || null)
  const changeWithValue = value => {
    setValue(value)
    if (value) {
      if (value.searchValue) {
        onChange(value)
      } else if (value.id) {
        onChange(value.id)
      } else {
        value.id = value.value
        value[labelKey] = value.value
        onChange(value)
      }
    } else {
      onChange(value)
    }
  }

  const specialCase = value => {
    setValue(value)
    if (value.id) {
      onChange(value)
    } else {
      value.id = value.value
      value[labelKey] = value.value
      onChange(value)
    }
  }

  const change = value => {
    if (value) {
      if (value.id) {
        onChange(value)
      } else {
        value.id = value.value
        value[labelKey] = value.value
        onChange(value)
      }
    } else {
      onChange(value)
    }
  }

  const selectStyles = {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      "& input": {
        font: "inherit",
      },
    }),
  }
  const getCreatorName = id => {
    let creators = props.authentication.authenticatedUser.companies.find(
      x => x.id === props.activeCompany
    )
      ? props.authentication.authenticatedUser.companies.find(
          x => x.id === props.activeCompany
        ).managers
      : []

    let creatorName = creators.find(x => x.id === id)
      ? creators.find(x => x.id === id)
      : null

    return creatorName
      ? creatorName.first_name + " " + creatorName.last_name
      : null
  }

  const parseJson = data => {
    let location = null
    try {
      location = data ? JSON.parse(data) : null
    } catch (e) {
      console.log(e)
    }
    return location
  }

  return creatable ? (
    <AsyncCreatableSelect
      classes={classes}
      styles={selectStyles}
      placeholder={placeholder}
      components={replaceComponents}
      value={value}
      onChange={value => {
        props.showValue
          ? labelKey == "full_name"
            ? specialCase(value)
            : changeWithValue(value)
          : change(value)
      }}
      createOptionPosition="first"
      getOptionLabel={option => {
        if (option.hasOwnProperty(labelKey)) {
          return option[labelKey]
        } else {
          return option.label
        }
      }}
      openMenuOnClick={false}
      // options={suggestions}
      // prop,
      // inputValue,
      // callback,
      // labelKey,placeholder,prrop,
      loadOptions={(a, b) =>
        loadOptions(prop, a, b, labelKey, placeholder, suggestions)
      }
      defaultOptions={props.openMenuOnClick}
      {...props}
    />
  ) : (
    <AsyncSelect
      classes={classes}
      styles={selectStyles}
      placeholder={placeholder}
      components={replaceComponents}
      value={value}
      onChange={value => {
        props.showValue
          ? placeholder == "Search Expense"
            ? specialCase(value)
            : changeWithValue(value)
          : change(value)
      }}
      getOptionLabel={option => {
        if (placeholder === "Search Shoots") {
          return {
            label: option[labelKey],
            date: option["start_date"],
            status: option["status"],
            creator: getCreatorName(option["creator_id"]),
            location: parseJson(option["location"]),
          }
        } else {
          return option[labelKey]
        }
      }}
      openMenuOnClick={false}
      // options={suggestions}
      loadOptions={(a, b) =>
        loadOptions(prop, a, b, labelKey, placeholder, suggestions)
      }
      // loadOptions={(a, b) => loadOptions(prop, a, b, suggestions, labelKey,props,placeholder,prrop)}
      defaultOptions={props.openMenuOnClick}
      {...props}
    />
  )
}
const mapStateToProps = state => {
  return {
    users: state.misc.users,
    authentication: state.authentication,
    activeCompany: state.companies.activeCompany,
  }
}
export default connect(mapStateToProps)(IntegrationReactSelect)
